import React, {FC, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {
    Button, Modal,
    ModalBody as Body,
    ModalFooter as Footer,
    ModalHeader as Header,
    ModalTitle as Title
} from "react-bootstrap";
import GroupedAction from "Entity/Collection/ListingSetting/GroupedAction";
import LoadingButton from "../../Button/LoadingButton";
import {getRequestFilters, MailingActionModal} from "../Listing";
import Api from "Vendor/Api";
import Collection from "Config/Collection";
import {createArrUtils} from "../../../Vendor/Utils/CreateArrayUtils";
import TextType from "../../../Vendor/Components/Form/Type/TextType";
import FormEmpty from "../../../Vendor/Components/FormEmpty";
import Property from "../../../Entity/Property";

export interface _GroupModalProps {
    collection?: Collection
    id?: number
    showActionModals: {[key: string]: boolean|Property}
    handleShowActionModal: (groupedAction?: GroupedAction, actionFromMain?:boolean) => void
    fromMain: boolean
    handleShowMainActionModal: () => void
    selected: number[]
    actionModalFormIsLoading: boolean
    actionModalFormIsLoaded: boolean,
    setActionModalFormIsLoaded: (isLoaded: boolean) => void,
    handleActionModalOnResponse: () => void
    handleActionModalOnSuccess: () => void
    handleActionModalOnSubmit: () => void
}

const _GroupModal: FC<_GroupModalProps> = ({
                                                 collection,
                                                 id,
                                                 showActionModals,
                                                 handleShowActionModal,
                                                 fromMain,
                                                 handleShowMainActionModal,
                                                 selected,
                                                 actionModalFormIsLoading,
                                                 actionModalFormIsLoaded,
                                                 setActionModalFormIsLoaded,
                                                 handleActionModalOnResponse,
                                                 handleActionModalOnSuccess,
                                                 handleActionModalOnSubmit,
}) => {
    const {t} = useTranslation()

    return <Modal show={showActionModals.group !== false} onHide={handleShowActionModal}>
        <Header closeButton={!fromMain}>
            <div className="modal-block-header">
                {fromMain && <i className="fa-solid fa-angle-left" onClick={handleShowMainActionModal}></i>}
                <Title>{t(`app.groupedActionTitle.group.${collection}`, {count: selected.length})}</Title>
            </div>
        </Header>
        <Body>
            <FormEmpty
                path={`/grouped-action/group/${collection}${id ? `/${id}` : ''}`}
                additionalData={{
                    items: selected,
                }}
                setIsLoaded={setActionModalFormIsLoaded}
                config={{
                    responseType: 'blob'
                }}
                onResponse={handleActionModalOnResponse}
                onSubmit={handleActionModalOnSubmit}
                onSuccess={handleActionModalOnSuccess}
            >
                <div className="row justify-content-end align-items-center mb-3">
                    <div className="col-auto">
                        {!fromMain && <Button variant="secondary" onClick={() => {
                            handleShowActionModal()
                        }}>
                            {t('app.cancel')}
                        </Button>}
                        <LoadingButton type="submit" isLoading={actionModalFormIsLoading} disabled={!actionModalFormIsLoaded}>
                            {t('app.change_group')}
                        </LoadingButton>
                    </div>
                </div>
            </FormEmpty>
        </Body>
    </Modal>
}

export default _GroupModal
